import {DataStatus} from 'platform/components';

import {useSelector} from 'react-redux';

import i18n from '@dms/i18n';
import {selectStructureTemplate, useRouter} from '@dms/teas';

import {AuditSettings} from './AuditSettings';

export const InspectionSettings = () => {
  const {params} = useRouter();
  const {id} = params;
  const template = useSelector(selectStructureTemplate(id as string));

  if (!template?.inspectionType) {
    return (
      <DataStatus
        isError
        errorMessage={i18n.t('page.vehicleSettings.labels.missingInspectionType')}
      />
    );
  }

  return <AuditSettings type={template.inspectionType} templateId={template?.id} />;
};
